import loadable from '@loadable/component';

export { default as ProductPlaceholder } from './Placeholder';

// default
export default loadable(() => import(/* webpackChunkName: "product-card" */ './Product'));
